module.exports = __webpack_public_path__ + "media/images/people-in-families-homelessness-436bd084219923d4142ec29526c6fb65.png";